import React from 'react';
import AuthScreen from '../components/auth/AuthScreen';

/** `/reset-password?token=` — the emailed link lands here (components/auth/AuthScreen). */
export default function ResetPasswordPage() {
  return <AuthScreen screen="reset" />;
}
